import type { AppModule } from '@shared/presentation/router/composition.js';

/**
 * `login` module: the public sign-in screen.
 *
 * It is a top-level route, outside the shell: whoever lands here has no session,
 * so there is no menu to render. Google comes back to this same route with
 * `?code=`.
 */
export const loginModule: AppModule = {
  name: 'login',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./presentation/LoginView.vue'),
      meta: { public: true },
    },
  ],
};
